import { Modal, Col } from "antd";
import { ModalWidth, ModalHeight, ModalSize } from "./InModal.default";
import React from "react";
import LoadingGate from "./LoadingGate";

export interface InModalProps {
  readonly open?: boolean;
  readonly title: string | React.ReactNode;
  readonly size: ModalSize;
  readonly children?: React.ReactNode;
  readonly actions: React.ReactNode;
  readonly onCancel?: () => void;
  // When loading, the body is replaced by a uniform loading gate (spinner + optional label / N-of-M progress) so the
  // form isn't shown empty while its datasets load.
  readonly loading?: boolean;
  readonly loadingProgress?: { readonly loaded: number; readonly total: number };
  readonly loadingLabel?: string;
}

function InModal(props: InModalProps) {
  return (
    <Modal
      open={props.open}
      destroyOnClose
      centered
      title={props.title}
      footer={props.actions}
      maskClosable={false}
      width={"auto"}
      height={"auto"}
      onCancel={props.onCancel}
    >
      <Col
        className={`flex flex-col overflow-hidden overflow-y-auto ${ModalHeight[props.size]} ${ModalWidth[props.size]}`}
      >
        <LoadingGate
          loading={props.loading}
          progress={props.loadingProgress}
          label={props.loadingLabel}
        >
          {props.children}
        </LoadingGate>
      </Col>
    </Modal>
  );
}

export default InModal;
